module.exports = __webpack_public_path__ + "static/media/img_prn13.3ab2c011.jpg";